import { tabs as AccountTabs } from '../../screens/landing-site/account';
import { acrossHosts } from './_';
import { adminRoutes } from './admin';
import { districtRoutes } from './district';
import { accountRoutes, exploreRoutes, landingRoutes, orgRoutes, propertyRoutes, onSubdomain } from './general';
const hasKey = (value, key) => key in value;
// What a page is called when a "Back to" link points at it; null for pages a back link should not name.
export const backLabel = (location) => {
    const at = location.ismatch;
    if (at(exploreRoutes.explore.path))
        return 'Explore';
    if (at(landingRoutes.root.path))
        return 'Home';
    if (at(districtRoutes.properties.path))
        return districtRoutes.properties.nav.label;
    if (at(adminRoutes.myProperties.path))
        return adminRoutes.myProperties.nav.label;
    if (at(adminRoutes.properties.path))
        return adminRoutes.properties.nav.label;
    if (at(accountRoutes.accountDefault.path))
        return AccountTabs['my-properties'].label;
    const account = at(accountRoutes.account.path);
    if (account)
        return hasKey(AccountTabs, account.tab) ? AccountTabs[account.tab].label : null;
    if (at(adminRoutes.stories.path))
        return adminRoutes.stories.nav.label;
    if (at(orgRoutes.story.path))
        return 'Story';
    if (at(propertyRoutes.property.path))
        return 'Property';
    return null;
};
// Where a property page sends a visitor with no recorded origin: the host's own list of properties.
export const defaultPropertyBack = () => onSubdomain
    ? { 'label': districtRoutes.properties.nav.label, 'href': districtRoutes.properties.getURL() }
    : { 'label': 'Explore', 'href': exploreRoutes.explore.getURL() };
// The link back from a page: to where the visitor came from when that page has a name, else to the fallback.
export const resolveBackLink = (parse, current, origin, fallback) => {
    if (origin === null)
        return fallback;
    const from = parse(origin);
    if (from.raw === current.raw)
        return fallback;
    const label = backLabel(from);
    if (label === null)
        return fallback;
    const href = acrossHosts(origin);
    // The fallback names its own page better than the table does, e.g. by address.
    return from.raw === parse(fallback.href).raw ? { 'label': fallback.label, href } : { label, href };
};
